import { Box, Button, FormControl, FormLabel, Grid, IconButton, InputAdornment, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import React, { useState, useCallback } from "react";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import UploadfileImage from "../../../../components/UploadfileImage";
import { toImageUrl } from "../../../../../utils/formatHelper";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

function FormUser({
    onClose = () => {},
    onSubmit = () => {},
    isCreateMode = false,
    roles = [],
    initailFormValues = {},
}) {
    const [handleShowPass, setHandleShowPass] = useState(false);
    const [handleSelect, setHandleSelect] = useState("");
    const [fileImage, setFileImage] = useState(
        initailFormValues?.imagePath
            ? [
                  {
                      id: 1,
                      name: initailFormValues?.imagePath,
                      src: toImageUrl(initailFormValues?.imagePath),
                  },
              ]
            : [],
    );

    // validation
    const validationSchema = yup.object({
        fullname: yup.string().required("Required"),
        roleId: yup
            .number()
            .nullable()
            .positive("Role must be positive.")
            .integer("Role must be integer.")
            .typeError("Role must be number.")
            .required("Required"),
        // phoneNumber: yup
        //     .string()
        //     .matches(/^\d+$/, "The field should have number only.")
        //     .required("Required"),
        // email: yup
        //     .string()
        //     .email("Valid email format is example@mail.com")
        //     .required("Required"),
        username: yup
            .string()
            .max(50, "Username should not be too long.")
            .required("Required"),
        password: isCreateMode
            ? yup
                  .string()
                  .min(4, "Please enter a minimum of 4 characters.")
                  .required("Required")
            : null,
        images: yup.array(),
    });

    // config form
    const formik = useFormik({
        initialValues: initailFormValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            onSubmit(values);
        },
    });

    const uploadImageFile = useCallback(
        file => {
            const reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = async evt => {
                setFileImage([{ id: 1, name: file[0].name, src: evt.target?.result }]);
            };
            formik.handleChange({
                target: {
                    type: "change",
                    id: "images",
                    name: "images",
                    value: [{ id: 1, name: file[0].name, src: file[0] }],
                },
            });
        },
        [setFileImage, formik],
    );

    const removeFile = file => {
        setFileImage(prev => (prev[0]?.id === file[0]?.id ? [] : prev));
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
                {/* Upload image */}
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={7}>
                            <p className="mb-3">Image <span className="text-danger">(200 x 200)</span></p>
                            <UploadfileImage
                                emptyImg={toAbsoluteUrl("/media/HCH/users/empty_img.png")}
                                onAcceptedFiles={uploadImageFile}
                                previewImages={fileImage}
                                removeButton={false}
                                removeAll={removeFile}
                                classPreview="col-6"
                                classActions="col-6"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {/* Name and lastname */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Fullname</FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="fullname"
                            variant="outlined"
                            size="small"
                            value={formik.values?.fullname}
                            onChange={formik.handleChange}
                            error={formik.touched?.fullname && Boolean(formik.errors?.fullname)}
                            helperText={formik.touched?.fullname && formik.errors?.fullname}
                        />
                    </FormControl>
                </Grid>

                {/* Access rights */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Access right</FormLabel>
                        {!formik.values?.isAdmin ? (
                            <Autocomplete
                                size="small"
                                value={handleSelect || formik.values?.Role}
                                onChange={(event, value) => {
                                    // custom for formik validate
                                    const e = {
                                        persist: () => {},
                                        target: {
                                            type: "change",
                                            id: "roleId",
                                            name: "roleId",
                                            value: value ? value?.id : 0,
                                        },
                                    };
                                    formik.handleChange(e);
                                    setHandleSelect(value);
                                }}
                                options={roles} // *** data = [] option
                                getOptionLabel={option => (option?.roleName ? option?.roleName : "")}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Cloose"
                                        variant="outlined"
                                        name="roleId"
                                        value={formik.values?.roleId}
                                        error={formik.touched?.roleId && Boolean(formik.errors?.roleId)}
                                        helperText={formik.touched?.roleId && formik.errors?.roleId}
                                    />
                                )}
                            />
                        ) : (
                            <div className="d-flex justify-content-start align-items-center py-2">
                                <div>Administrator</div>
                            </div>
                        )}
                    </FormControl>
                </Grid>

                {/* Phone */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Phone</FormLabel>
                        <TextField
                            fullWidth
                            type="tel"
                            name="phoneNumber"
                            variant="outlined"
                            size="small"
                            value={formik.values?.phoneNumber}
                            onChange={formik.handleChange}
                            error={formik.touched?.phoneNumber && Boolean(formik.errors?.phoneNumber)}
                            helperText={formik.touched?.phoneNumber && formik.errors?.phoneNumber}
                        />
                    </FormControl>
                </Grid>

                {/* email */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Email</FormLabel>
                        <TextField
                            fullWidth
                            type="email"
                            name="email"
                            variant="outlined"
                            size="small"
                            value={formik.values?.email}
                            onChange={formik.handleChange}
                            error={formik.touched?.email && Boolean(formik.errors?.email)}
                            helperText={formik.touched?.email && formik.errors?.email}
                        />
                    </FormControl>
                </Grid>

                {/* username */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Username</FormLabel>
                        <TextField
                            fullWidth
                            type="text"
                            name="username"
                            variant="outlined"
                            size="small"
                            value={formik.values?.username}
                            onChange={formik.handleChange}
                            error={formik.touched?.username && Boolean(formik.errors?.username)}
                            helperText={formik.touched?.username && formik.errors?.username}
                        />
                    </FormControl>
                </Grid>

                {/* password */}
                <Grid item xs={12} md={6}>
                    <FormControl className="t-form-group-custom" fullWidth>
                        <FormLabel className="text-dark mb-4">Password</FormLabel>
                        <TextField
                            fullWidth
                            type={handleShowPass ? "text" : "password"}
                            name="password"
                            variant="outlined"
                            size="small"
                            value={formik.values?.password}
                            onChange={formik.handleChange}
                            error={formik.touched?.password && Boolean(formik.errors?.password)}
                            helperText={formik.touched?.password && formik.errors?.password}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setHandleShowPass(!handleShowPass)}>
                                            {handleShowPass ? (
                                                <VisibilityOff style={{ color: "#808080" }} />
                                            ) : (
                                                <Visibility style={{ color: "#808080" }} />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>
                </Grid>

                {/* actions */}
                <Grid item xs={12}>
                    <Box className="row justify-content-lg-end">
                        <div className="col-6 col-lg-3 ">
                            <Button type="submit" className="w-100 btn t-btn-primary">
                                <i className="fas fa-save mr-1" style={{ color: "inherit" }}></i>
                                {isCreateMode ? "Create" : "Update"}
                            </Button>
                        </div>
                        <div className="col-6 col-lg-3 ">
                            <Button type="button" onClick={onClose} className="w-100 btn t-btn-gray">
                                cancel
                            </Button>
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
}

export default FormUser;
